import React, { useEffect, useState } from 'react';
import TendersTable from '../procurement/tenders/TendersTable';
import { publisherTenderAPI } from '../../utils/api';

export default function PublisherTendersPage(){
  const [rows,setRows]=useState([]);
  useEffect(()=>{ publisherTenderAPI.list().then(res=>setRows(res.data)); },[]);
  return (
    <div className="eduss-taluka-management">
      <div className="eduss-page-header"><div><h2>My Tenders</h2><p>Tenders you are qualified for</p></div></div>
      <div className="eduss-taluka-management-content">
        <TendersTable rows={rows} readOnly={true} />
      </div>
    </div>
  );
}
